module.exports = __webpack_public_path__ + "img/Frame 66428.2842a60c.png";